import React from 'react';
import { ExternalLink, ArrowUpRight } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
export function Portfolio() {
  const {
    t
  } = useLanguage();
  const projects = [{
    id: 1,
    titleKey: 'fitness' as const,
    // Fitness gym interior photo
    image: 'https://images.unsplash.com/photo-1534438327276-14e5300c3a48?w=800&q=80',
    accent: 'from-orange-500/30 to-red-500/30',
    // Replace with your actual fitness studio website URL
    url: 'https://project-fitness-coach-portfolio-780.magicpatterns.app'
  }, {
    id: 2,
    titleKey: 'beauty' as const,
    // Beauty salon interior photo
    image: 'https://images.unsplash.com/photo-1560066984-138dadb4c035?w=800&q=80',
    accent: 'from-pink-500/30 to-rose-500/30',
    // Replace with your actual beauty studio website URL
    url: 'https://your-beauty-studio-site.com'
  }];
  return <section id="portfolio" className="py-24 bg-slate-950 relative" data-id="element-147">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-148">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-16 gap-6" data-id="element-149">
          <div data-id="element-150">
            <h2 className="text-3xl md:text-5xl font-bold text-white mb-4" data-id="element-151">
              {t.portfolio.title}
            </h2>
            <p className="text-slate-400 max-w-xl" data-id="element-152">{t.portfolio.subtitle}</p>
          </div>
          <a href="#contact" className="text-cyan-400 font-medium hover:text-cyan-300 flex items-center gap-2 group" data-id="element-153">
            {t.portfolio.cta}{' '}
            <ArrowUpRight className="group-hover:-translate-y-0.5 group-hover:translate-x-0.5 transition-transform" data-id="element-154" />
          </a>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-155">
          {projects.map(project => <a key={project.id} href={project.url} target="_blank" rel="noopener noreferrer" className="group relative rounded-2xl overflow-hidden bg-slate-900 border border-white/5 hover:border-cyan-500/30 transition-all duration-300 hover:-translate-y-1 cursor-pointer block" data-id="element-156">
              {/* Project Image */}
              <div className="aspect-[4/3] w-full relative overflow-hidden" data-id="element-157">
                <img src={project.image} alt={t.portfolio.projects[project.titleKey].title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" data-id="element-158" />
                <div className={`absolute inset-0 bg-gradient-to-br ${project.accent} opacity-40 group-hover:opacity-20 transition-opacity`} data-id="element-159" />

                {/* Overlay Content */}
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300 bg-slate-950/60 backdrop-blur-sm" data-id="element-160">
                  <span className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-white text-slate-950 font-medium text-sm shadow-xl" data-id="element-161">
                    {t.portfolio.viewCase} <ExternalLink size={14} data-id="element-162" />
                  </span>
                </div>
              </div>

              {/* Content */}
              <div className="p-6" data-id="element-163">
                <p className="text-cyan-400 text-sm font-medium mb-2" data-id="element-164">
                  {t.portfolio.projects[project.titleKey].category}
                </p>
                <h3 className="text-xl font-bold text-white group-hover:text-cyan-400 transition-colors" data-id="element-165">
                  {t.portfolio.projects[project.titleKey].title}
                </h3>
              </div>
            </a>)}
        </div>
      </div>
    </section>;
}